import React from 'react';
import { Skeleton, SkeletonCard } from './Skeleton';

export const SkillSkeleton = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
      {[...Array(6)].map((_, i) => (
        <SkeletonCard key={i} className="p-6 bg-slate-900/50 border border-slate-800/50 rounded-3xl flex flex-col items-center gap-4">
          <Skeleton variant="circle" width="64px" height="64px" className="rounded-2xl" />
          <Skeleton width="60%" height="16px" />
        </SkeletonCard>
      ))}
    </div>
  );
};

export const ProjectSkeleton = () => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {[...Array(4)].map((_, i) => (
        <SkeletonCard key={i} className="bg-slate-900 rounded-[32px] border border-white/5 overflow-hidden flex flex-col h-[400px]">
          <Skeleton height="240px" width="100%" />
          <div className="p-6 space-y-4">
            <Skeleton width="70%" height="24px" />
            <Skeleton width="100%" height="16px" />
            <Skeleton width="100%" height="16px" />
            <div className="flex gap-2">
              <Skeleton width="60px" height="24px" className="rounded-full" />
              <Skeleton width="60px" height="24px" className="rounded-full" />
            </div>
          </div>
        </SkeletonCard>
      ))}
    </div>
  );
};

export const TestimonialSkeleton = () => {
  return (
    <div className="grid md:grid-cols-3 gap-8">
      {[...Array(3)].map((_, i) => (
        <SkeletonCard key={i} className="p-8 bg-slate-900/50 border border-slate-800 rounded-[32px] flex flex-col gap-6">
          <div className="flex items-center gap-4">
            <Skeleton variant="circle" width="56px" height="56px" className="rounded-2xl" />
            <div className="space-y-2 flex-1">
              <Skeleton width="60%" height="16px" />
              <Skeleton width="40%" height="12px" />
            </div>
          </div>
          <div className="space-y-2">
            <Skeleton width="100%" height="14px" />
            <Skeleton width="100%" height="14px" />
            <Skeleton width="80%" height="14px" />
          </div>
        </SkeletonCard>
      ))}
    </div>
  );
};
